import { useEffect, useRef, useState } from "react";
import { photoUrl } from "@/lib/api";
import { ImagePlus, X, Footprints } from "lucide-react";
import { toast } from "sonner";

const TYPES = ["image/jpeg", "image/png", "image/webp"];

// Pick a photo locally; parent uploads it after saving the color
export default function PhotoPicker({ currentPath, file, onFile, removed, onRemove }) {
  const input = useRef(null);
  const [preview, setPreview] = useState("");

  useEffect(() => {
    if (!file) { setPreview(""); return undefined; }
    const url = URL.createObjectURL(file);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const shown = preview || (!removed && photoUrl(currentPath));

  const choose = (f) => {
    if (!f) return;
    if (!TYPES.includes(f.type)) { toast.error("Sadece JPG, PNG veya WEBP"); return; }
    if (f.size > 5 * 1024 * 1024) { toast.error("Fotoğraf en fazla 5 MB olabilir"); return; }
    onFile(f);
  };

  return (
    <div className="flex items-center gap-4">
      <div className="w-28 h-28 rounded-md border border-[#DCCFB8] bg-[#EFE6D6] overflow-hidden flex items-center justify-center shrink-0"
        data-testid="color-photo-preview">
        {shown ? <img src={shown} alt="Model fotoğrafı" className="w-full h-full object-cover" />
          : <Footprints className="w-8 h-8 text-[#A8977F]" />}
      </div>
      <div className="flex flex-col gap-2">
        <input ref={input} type="file" accept={TYPES.join(",")} className="hidden" data-testid="color-photo-input"
          onChange={(e) => { choose(e.target.files?.[0]); e.target.value = ""; }} />
        <button type="button" onClick={() => input.current?.click()} data-testid="color-photo-choose-btn"
          className="inline-flex items-center gap-2 h-9 px-3 rounded-md border border-[#D97706]/60 text-[#B45309] hover:bg-[#EFE6D6] text-sm">
          <ImagePlus className="w-4 h-4" /> {shown ? "Fotoğrafı Değiştir" : "Fotoğraf Ekle"}
        </button>
        {shown && (
          <button type="button" onClick={() => { onFile(null); onRemove(); }} data-testid="color-photo-remove-btn"
            className="inline-flex items-center gap-2 h-9 px-3 rounded-md text-[#8C7B68] hover:text-[#EF4444] text-sm">
            <X className="w-4 h-4" /> Kaldır
          </button>
        )}
        <span className="text-[11px] text-[#8C7B68]">JPG, PNG veya WEBP · en fazla 5 MB</span>
      </div>
    </div>
  );
}
